import React, {Component} from "react";
import {connect} from "react-redux";
import commonActionCreators from "../../../shared/store/common/action-creators";
import usersActionCreators from "../../store/users/action-creators";

class SignActorsManageSingle extends Component {

  filterOfficersForSignFlow(formType, signFlowStep) {
    const signFlow = this.props.signFlow[formType];
    const signFlowRoles = signFlow[signFlowStep];

    let users = [];
    if (signFlowRoles && signFlowRoles.roles) {
      users = this.props.users && this.props.users.filter(u => signFlowRoles.roles.some(v => u.roles.map(user => user.scope).includes(v)))
    }

    return users;
  }

  fromTypeSignActors(formType, actor) {
    let signActors = this.props.signActors && this.props.signActors.find(sa => sa.type === formType);
    let trainingPhaseSignActors = this.props.trainingPhaseSignActors && this.props.trainingPhaseSignActors.find(sa => sa.type === formType);


    return (signActors && signActors[actor]) || (trainingPhaseSignActors && trainingPhaseSignActors[actor]) || ""
  }

  onAddSignActor(formType, actor, guid) {
    let signActor = this.props.signActors && this.props.signActors.find(sa => sa.type === formType);
    let signActors = [];

    let signActorsTemp = this.props.signActors;

    if(!signActor) {
      signActors = [...(signActorsTemp || []), {
        type: formType,
        approverOne: null,
        approverTwo: null,
        [actor]: guid
      }]
    } else {
      signActors = signActorsTemp.map(sa =>
        sa.type === formType
          ? {
            ...sa,
            [actor]: guid
          }
          : sa)
    }

    this.props.onSignActorsUpdate && this.props.onSignActorsUpdate(signActors)
  }

  render() {
    return (
      <div className="sign-actors-manage-single">
        <div className="form-sign-choose-user">
          <div className="form-sign-label"><b>Set new approver</b></div>
          <select
            className="form-control"
            value={this.fromTypeSignActors(this.props.formType, this.props.actor)}
            onChange={(e) => this.onAddSignActor(this.props.formType, this.props.actor, e.target.value)}>
            <option value={''}>Set approver</option>
            { this.filterOfficersForSignFlow(this.props.formType, this.props.signFlowStep).map(u => (
              <option key={u.guid} value={u.guid}>{u.getFullName()}</option>
            ))}
          </select>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  formTypes: state.common.formTypes,
  users: state.users.usersByMaster,
  forms: state.forms.list,
});

const mapDispatchToProps = (dispatch) => ({
  fetchFormTypes: () => dispatch(commonActionCreators.fetchFormTypes()),
  fetchUsers: () => dispatch(usersActionCreators.fetchUsersByMaster())
});

export default connect(mapStateToProps, mapDispatchToProps)(SignActorsManageSingle);
